import { useState, useEffect, useCallback } from 'react';

const PHOTOS = [
  {
    src: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/5a72c1d8-20bd-41f0-9c28-c02e21b58c0a_compressed_IMG_0425.webp',
    alt: 'Кованые качели — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Finished%20wrought%20iron%20garden%20swing%20with%20canopy%20and%20wooden%20seat%20installed%20in%20private%20garden%20Russia%20summer%20daylight%20decorative%20forged%20elements%20dark%20paint%20realistic%20photo&width=800&height=600&seq=swing-work-1&orientation=landscape',
    alt: 'Садовые качели с навесом — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Elegant%20metal%20garden%20swing%20for%20two%20persons%20soft%20cushions%20and%20shade%20canopy%20in%20Russian%20private%20backyard%20green%20lawn%20summer%20sunny%20day%20realistic%20architectural%20photo&width=800&height=600&seq=swing-work-2&orientation=landscape',
    alt: 'Качели для двоих — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Decorative%20wrought%20iron%20bench%20swing%20with%20ornate%20scrollwork%20frame%20and%20wooden%20seat%20hanging%20in%20garden%20Russia%20daytime%20realistic%20photo%20dark%20metal%20finish&width=800&height=600&seq=swing-work-3&orientation=landscape',
    alt: 'Кованые качели-скамейка — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Large%20family%20metal%20garden%20swing%20set%20with%20canopy%20and%20side%20benches%20installed%20in%20backyard%20Russia%20summer%20children%20playing%20warm%20daylight%20realistic%20photo&width=800&height=600&seq=swing-work-4&orientation=landscape',
    alt: 'Семейные качели с навесом — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20hanging%20swing%20chair%20with%20cushion%20attached%20to%20metal%20frame%20in%20garden%20Russia%20private%20house%20green%20trees%20background%20summer%20daylight%20realistic%20photo&width=800&height=600&seq=swing-work-5&orientation=landscape',
    alt: 'Качели-кресло подвесные — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Classic%20forged%20garden%20swing%20with%20polycarbonate%20canopy%20roof%20black%20metal%20frame%20installed%20in%20Russian%20private%20garden%20summer%20realistic%20photo%20close%20up%20details&width=800&height=600&seq=swing-work-6&orientation=landscape',
    alt: 'Качели с поликарбонатным навесом — готовый объект',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Cozy%20garden%20swing%20with%20side%20table%20and%20soft%20cushions%20wrought%20iron%20decorative%20frame%20with%20scrollwork%20Russia%20summer%20private%20garden%20afternoon%20light%20realistic%20photo&width=800&height=600&seq=swing-work-7&orientation=landscape',
    alt: 'Качели со столиком — готовый объект',
  },
];

export default function VariantsSection() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const open = (idx: number) => setLightboxIndex(idx);
  const close = () => setLightboxIndex(null);

  const goPrev = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? (prev - 1 + PHOTOS.length) % PHOTOS.length : null));
  }, []);

  const goNext = useCallback(() => {
    setLightboxIndex((prev) => (prev !== null ? (prev + 1) % PHOTOS.length : null));
  }, []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') goPrev();
      if (e.key === 'ArrowRight') goNext();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [lightboxIndex, goPrev, goNext]);

  const currentPhoto = lightboxIndex !== null ? PHOTOS[lightboxIndex] : null;

  return (
    <>
      <section className="py-16 md:py-20 bg-background-100">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              Примеры наших работ
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Реальные качели, которые мы уже изготовили и установили для наших клиентов
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-3">
            {PHOTOS.map((photo, idx) => (
              <div
                key={idx}
                role="button"
                tabIndex={0}
                onClick={() => open(idx)}
                onKeyDown={(e) => { if (e.key === 'Enter') open(idx); }}
                className="relative group rounded-md overflow-hidden bg-background-200 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400"
              >
                <div className="w-full h-44 md:h-52">
                  <img
                    src={photo.src}
                    alt={photo.alt}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/20 text-background-50">
                    <i className="ri-zoom-in-line text-xl"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {currentPhoto && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm animate-fade-in"
          onClick={close}
        >
          <button
            onClick={close}
            className="whitespace-nowrap absolute top-5 right-5 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Закрыть"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
            className="whitespace-nowrap absolute left-3 md:left-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Предыдущее"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); goNext(); }}
            className="whitespace-nowrap absolute right-3 md:right-6 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 text-background-50 transition-colors cursor-pointer"
            aria-label="Следующее"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          <div
            className="max-w-[90vw] max-h-[85vh] flex flex-col items-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={currentPhoto.src}
              alt={currentPhoto.alt}
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-background-50/80 text-sm text-center mt-4 max-w-lg">
              {currentPhoto.alt}
            </p>
            <p className="text-background-50/40 text-xs mt-1">
              {lightboxIndex! + 1} / {PHOTOS.length}
            </p>
          </div>
        </div>
      )}
    </>
  );
}